/** Coerce API payloads to an array. Objects like `{ data: [] }` must not hit `.forEach`. */
export function asList(value) {
  if (Array.isArray(value)) return value;
  if (value == null) return [];
  if (typeof value !== 'object') return [];
  if (Array.isArray(value.data)) return value.data;
  if (Array.isArray(value.rows)) return value.rows;
  if (Array.isArray(value.items)) return value.items;
  if (Array.isArray(value.jobs)) return value.jobs;
  return [];
}
